<template>
  <v-container class="pdf2pog-overview pa-4 pa-md-6">
    <v-row>
      <v-col cols="12">
        <h1 class="text-h4 font-weight-bold mb-2">PDF &gt; AutoPOG</h1>
        <p class="text-body-1 mb-0">
          Key utility tools to assist with importing data into AXP
        </p>
      </v-col>
    </v-row>

    <v-row class="mt-2">
      <v-col cols="12" md="6">
        <v-card outlined class="workflow-card pa-2">
          <v-card-title class="text-h6 d-flex align-center">
            <span>AutoPOG</span>
          </v-card-title>
          <v-card-text>
            Import planogram data into AXP using the AutoPOG workflow.
          </v-card-text>
          <v-card-actions>
            <v-btn color="primary" @click="$router.push('/pdf2excel/tabular')">
              Open AutoPOG
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: 'PDFAutoPOG'
}
</script>

<style scoped>
.pdf2pog-overview {
  max-width: 1200px;
}

.workflow-card {
  height: 100%;
}
</style>
